import { render } from "./Cropper.vue?vue&type=template&id=1671e49a&scoped=true"
import script from "./Cropper.vue?vue&type=script&lang=js"
export * from "./Cropper.vue?vue&type=script&lang=js"

import "./Cropper.vue?vue&type=style&index=0&id=1671e49a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1671e49a"]])

export default __exports__